<template>
  <BikefittingLayout>
    <template #header>
      <TheHeader />
    </template>

    <RouterView />
  </BikefittingLayout>
</template>

<script setup lang="ts">
import BikefittingLayout from '@/components/layout/BikefittingLayout.vue'
import TheHeader from '@/components/layout/TheHeader.vue'
</script>

<style lang="scss"></style>
